import "./header.css";
import { useState } from "react";
import logo from "../../assets/images/others/logo.png";
import { Menu, Close, ChevronRight, ChevronLeft } from '@material-ui/icons';
import discordImg from "assets/images/others/discord.svg";
import { Link } from "react-router-dom";

const Header = () => {
    const [sideBar, setSideBar] = useState(false);

    // go to the section
    const scrollTo_Section = (sec_id) => {
        let element = document.getElementById(sec_id);
        const yOffset = -127;
        if (element) {
            const y = element.getBoundingClientRect().top + window.pageYOffset + yOffset;
            window.scrollTo({ top: y, behavior: 'smooth' });
        }
    };
    return (
        <>
            <header className="web-header">
                <div className="row header-container">
                    {/* <div > */}
                        <Link to="/" className="header-logo-area row">
                            <img
                                onClick={() => scrollTo_Section('home')}
                                className="header-main-logo"
                                loading="lazy"
                                src={logo}
                                alt="" />
                            <span className="header-text-logo">Business Ape Club</span>
                        </Link>
                    {/* </div> */}
                    <div className="header-right-area">
                        <a href="https://discord.gg/eqWG6CuyqC" target="_blank" rel="noopener noreferrer" className="header-join-btn row">
                            Join Discord
                            <img src={discordImg} alt="" />
                        </a>
                        <div className="menu-btn">
                            {sideBar ?
                                <Close onClick={() => setSideBar(false)} className="menu-icon" />
                                : <Menu onClick={() => setSideBar(true)} className="menu-icon" />
                            }
                        </div>
                    </div>
                </div>
                <div className="sidebar-open-btn" onClick={() => setSideBar(true)}>
                    <ChevronLeft className="chev-icon" />
                </div>
                {sideBar && <div onClick={() => setSideBar(false)} className="backdrop-sidebar"></div>}
                <nav className={`side-bar-wrapper ${sideBar ? 'opened-sidebar' : ''}`}>
                    <div className="side-logo">
                        <img loading="lazy" src={logo} alt="" />
                    </div>
                    <ul>
                        <li><button className="header-links" onClick={() => { setSideBar(false); scrollTo_Section('about'); }}>About</button></li>
                        <li><button className="header-links" onClick={() => { setSideBar(false); scrollTo_Section('nft') }}>Collection</button></li>
                        <li><button className="header-links" onClick={() => { setSideBar(false); scrollTo_Section('story'); }}> story</button></li>
                        {/* <li><button className="header-links" onClick={() => { setSideBar(false); scrollTo_Section('discord') }}>Utilities</button></li> */}
                        <li><button className="header-links" onClick={() => { setSideBar(false); scrollTo_Section('roadmap') }}>Roadmap</button></li>
                        <li><button className="header-links" onClick={() => { setSideBar(false); scrollTo_Section('team') }}>Team</button></li>
                        {/* <li><Link to="/preSale" className="header-links">PreSale</Link></li> */}
                        <li><Link to="/stake" className="header-links">Jungle Bonds</Link></li>
                        {/* <li>
                            <a href="https://discord.gg/eqWG6CuyqC" target="_blank" rel="noopener noreferrer" className="header-join-btn side-join-btn row">
                                Join Discord
                                <img src={discordImg} alt="" />
                            </a>
                        </li> */}
                    </ul>
                    <div className="social sidebar-socials row">
                        <div className="link">
                            <a href="https://www.instagram.com/businessapeclub/" target="_blank" rel="noopener noreferrer" className="insta row">.</a>
                        </div>
                        <div className="link">
                            <a href="https://twitter.com/BusinessApeClub" target="_blank" rel="noopener noreferrer" className="twitter row">.</a>
                        </div>
                        <div className="link">
                            <a href="https://discord.gg/eqWG6CuyqC" target="_blank" rel="noopener noreferrer" className="discord row">.</a>
                        </div>
                        <div className="link">
                            <a href="https://www.tiktok.com/@businessapeclub?" target="_blank" rel="noopener noreferrer" className="tiktok row">.</a>
                        </div>
                    </div>
                    <div className="sidebar-close-btn" onClick={() => setSideBar(false)}>
                        <ChevronRight className="chev-icon" />
                    </div>
                </nav>
            </header>
            <div className="header-spacer"></div>
        </>
    )
}

export default Header
